<template>
  <div v-on="$listeners"
       :style="containerStyle">
    <div v-if="!textBottom"
         :style="textStyle">
      <slot>
        There is no data to show.
      </slot>
    </div>
    <BaseImage :src="require('@img/eye_glass.png')"
               :style="imageStyle" />
    <div v-if="textBottom"
         :style="textStyle">
      <slot>
        There is no data to show.
      </slot>
    </div>
  </div>
</template>

<script>
  import BaseImage from '@base/base-image'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'NoDataToShow',
    inheritAttrs: false,
    components: {
      BaseImage,
    },
    props: {
      textBottom: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          width: '100%',
        },
        imageStyle: {
          display: 'block',
          height: '130px',
          width: '174px',
        },
        textStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
          textAlign: 'center',
        },
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        color: this.color.dark2(),
        ...this.$attrs,
      };

      this.textStyle = {
        ...this.textStyle,
        margin: this.textBottom ? `${Layout.space.lg} 0 0 0` : `0 0 ${Layout.space.lg} 0`,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
